var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Admin" } }, [
    !_vm.ready
      ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
      : _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("GChart", {
                        attrs: {
                          data: _vm.chartData1,
                          options: {
                            title: "รูปแบบ",
                            pieHole: 0.5,
                            width: 600,
                            height: 600
                          },
                          width: "800",
                          type: "PieChart"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("GChart", {
                        attrs: {
                          data: _vm.chartData2,
                          options: {
                            title: "กิจการเจ้าของคนเดียว",
                            pieHole: 0.5,
                            width: 600,
                            height: 600
                          },
                          width: "800",
                          type: "PieChart"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("GChart", {
                        attrs: {
                          data: _vm.chartData3,
                          options: {
                            title: "บริษัท / ห้างหุ้นส่วน",
                            pieHole: 0.5,
                            width: 600,
                            height: 600
                          },
                          type: "PieChart"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("h4", [_vm._v("รูปแบบธุรกิจ")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("h4", [_vm._v("ประเภทธุรกิจ")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d1bc473", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1bc473","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/analytics/BusinessType.vue
// module id = null
// module chunks = 